import React from 'react';
import { Card, CardContent } from '../ui/card';
import { 
  User, 
  Settings, 
  Shield, 
  Activity,
  Crown 
} from 'lucide-react';

const ProfileSidebar = ({ activeSection, setActiveSection }) => {
  const sidebarItems = [
    { id: 'profile', label: 'Profile', icon: User },
    { id: 'subscription', label: 'Subscription', icon: Crown },
    { id: 'settings', label: 'Settings', icon: Settings },
    { id: 'security', label: 'Security', icon: Shield },
    { id: 'activity', label: 'Activity', icon: Activity },
  ];

  return (
    <div className="lg:w-64 flex-shrink-0">
      <Card>
        <CardContent className="p-4">
          <nav className="space-y-2">
            {sidebarItems.map((item) => {
              const Icon = item.icon;
              return (
                <button
                  key={item.id}
                  onClick={() => setActiveSection(item.id)}
                  className={`w-full flex items-center gap-3 px-3 py-2 text-left rounded-lg transition-colors ${
                    activeSection === item.id
                      ? 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 font-medium'
                      : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  {item.label}
                </button>
              );
            })}
          </nav>
        </CardContent>
      </Card>
    </div>
  );
};

export default ProfileSidebar;
